import { createFileRoute, Outlet } from '@tanstack/react-router';
import { devicesQuery } from '@/features/devices/api';

/**
 * "Konnektorlar" module (03-modules §1.2): the registry (`index`) and the detail page of one connector
 * (`$connectorId`). Prefetches the devices — bindings show the tenant's real indicators.
 */
export const Route = createFileRoute('/_authed/t/$tenantSlug/_shell/connectors')({
  loader: ({ context }) => {
    void context.queryClient.prefetchQuery(devicesQuery(context.tenant.id));
  },
  component: Outlet,
});
